import { Dropdown } from 'antd';
import classNames from 'classnames';
import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import './style.css';

const dropdownTrigger = ['click'];

const LabeledDropdown = ({
  dropdownItems,
  labelId,
  labelDefaultMessage,
  value,
  readOnly,
}) => {
  const dropdownMenu = useMemo(
    () => ({ items: dropdownItems }),
    [dropdownItems],
  );

  return (
    <div className={classNames('labeled-dropdown-container', { readOnly })}>
      {labelId && (
        <div className="labeled-dropdown-label">
          <label>
            <FormattedMessage
              id={labelId}
              defaultMessage={labelDefaultMessage || labelId}
            />
          </label>
        </div>
      )}
      <Dropdown
        menu={dropdownMenu}
        trigger={dropdownTrigger}
        disabled={readOnly}
      >
        <div className={`labeled-dropdown-input ${readOnly ? 'disabled': ''}`}>
          {typeof value === 'string' ? (
            <FormattedMessage
              id={value?.toUpperCase()?.replace(' ', '_').replace('-', '_')}
              defaultMessage={value}
            />
          ) : (
            value
          )}
        </div>
      </Dropdown>
    </div>
  );
};

export default LabeledDropdown;
